import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { CheckCircle2, XCircle, Loader2, ArrowRight } from 'lucide-react';
import { Logo } from '@/components/Logo';

export default function VerifyEmail() {
  const { token } = useParams();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/auth/verify/${token}`);
        setStatus('success');
        setMessage(data.message || 'Email vérifié');
      } catch (err) {
        setStatus('error');
        setMessage(err?.response?.data?.error || 'Lien invalide ou expiré');
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen bg-white grid place-items-center p-4" data-testid="verify-email-page">
      <div className="card max-w-md w-full text-center slide-up">
        <Link to="/" className="inline-flex items-center gap-2 mb-8">
          <Logo size={28} />
          <span className="font-display text-xl font-black tracking-tight text-slate-900">AssoPerf</span>
        </Link>
        {status === 'loading' && (
          <>
            <Loader2 className="w-12 h-12 mx-auto mb-4 animate-spin text-slate-400" />
            <h1 className="font-display text-2xl font-black text-slate-900 mb-2">Vérification en cours…</h1>
            <p className="text-slate-500 text-sm">Nous validons votre email, un instant.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="w-16 h-16 rounded-full grid place-items-center mx-auto mb-5" style={{ background: 'rgba(16, 185, 129, 0.1)' }}>
              <CheckCircle2 className="w-9 h-9 text-emerald-500" />
            </div>
            <h1 className="font-display text-3xl font-black text-slate-900 mb-2">Email vérifié</h1>
            <p className="text-slate-500 text-sm mb-6">Votre adresse est confirmée. Vous pouvez maintenant accéder à votre espace.</p>
            <Link to="/login" className="btn-primary w-full justify-center flex items-center gap-2" style={{ background: '#0052FF' }} data-testid="verify-login-link">
              Se connecter <ArrowRight className="w-4 h-4" />
            </Link>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="w-16 h-16 rounded-full grid place-items-center mx-auto mb-5" style={{ background: 'rgba(239, 68, 68, 0.1)' }}>
              <XCircle className="w-9 h-9 text-red-500" />
            </div>
            <h1 className="font-display text-3xl font-black text-slate-900 mb-2">Lien invalide</h1>
            <p className="text-slate-500 text-sm mb-6">{message}. Demandez un nouveau lien depuis la page de connexion.</p>
            <Link to="/login" className="btn-outline w-full justify-center flex" data-testid="verify-back-login">
              Retour à la connexion
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
